import store from '@/store'

export default async function(to, from, next) {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (!store.getters['wAuth/isLoggedIn']) {
			return next({ name: 'Login' })
		}
	}
    
	return next()
}